import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {ConsentUseCaseBasicModel} from '@core/modules/rest/consent-use-case/response/consent-use-case-basic.model';

@Component({
    selector: 'app-wizard-step-consent-use-cases',
    templateUrl: './wizard-step-consent-use-cases.component.html',
    styleUrls: ['./wizard-step-consent-use-cases.component.scss']
})
export class WizardStepConsentUseCasesComponent implements OnChanges {

    @Input() consentUseCases: ConsentUseCaseBasicModel[] | undefined;
    @Input() customUseCasesVisible: boolean | undefined;
    @Output() useCaseStepEvent: EventEmitter<ConsentUseCaseBasicModel> = new EventEmitter();
    @Output() selectedTab: EventEmitter<number> = new EventEmitter();
    @Output() myUseCaseEvent = new EventEmitter<ConsentUseCaseBasicModel>();

    step = 1;
    predefinedUseCases: ConsentUseCaseBasicModel[] = [];
    customUseCase: ConsentUseCaseBasicModel | undefined;

    selectTab(selectStep: number): void {
        this.step = selectStep;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.consentUseCases && this.consentUseCases && this.predefinedUseCases.length === 0) {
            this.consentUseCases.forEach(useCase => {
                if (useCase.uniqueTitle !== 'Custom') {
                    this.predefinedUseCases.push(useCase);
                } else {
                    this.customUseCase = useCase;
                }
            });
        }
    }

    onKeyUp(event: any, step: number): void {
        if (event.key === 'Enter' || event.code === 'Space') {
            this.selectTab(step);
        }
    }
}
